namespace GeniuzPOS.InitialData {
    export interface PsPosStationForm {
        PosId: Serenity.StringEditor;
        PosPermitNo: Serenity.StringEditor;
        ShopId: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        LastReceiptRunNo: Serenity.DecimalEditor;
        LastRefundRunNo: Serenity.DecimalEditor;
        CashierPosFg: Serenity.EnumEditor;
        PromptPayLink: Serenity.StringEditor;
        PosScreenType: Serenity.RadioButtonEditor;
        QRCodeAccount: Serenity.StringEditor;
        PosTouchPanelId: Serenity.LookupEditor;
        MaxCashInDrawer: Serenity.DecimalEditor;
        SellingPriceNo: Serenity.EnumEditor;
        AutoChargeFg: Serenity.EnumEditor;
        AutoChargeRate: Serenity.DecimalEditor;
        MandatorySalesmanFg: Serenity.EnumEditor;
        MandatoryMemberFg: Serenity.EnumEditor;
        ConnectPrinterFg: Serenity.EnumEditor;
        ConnectDrawerFg: Serenity.EnumEditor;
        ConnectVfdFg: Serenity.EnumEditor;
        Connect2ndDispFg: Serenity.EnumEditor;
        ConnectRfidReaderFg: Serenity.EnumEditor;
        ConnectEdcFg: Serenity.EnumEditor;
        ConnectEdcPort: Serenity.LookupEditor;
        EdcBank: Serenity.LookupEditor;
        PsParaDefault1: Serenity.BooleanEditor;
        ShopLogoOnFrontScreen: Serenity.ImageUploadEditor;
        ShopLogoOnReceipt: Serenity.ImageUploadEditor;
        RecptHeadMesgFontSize: Serenity.StringEditor;
        RecptHeadMesgTextAlign: Serenity.RadioButtonEditor;
        RecptHeadMesg1: Serenity.StringEditor;
        RecptHeadMesg2: Serenity.StringEditor;
        RecptHeadMesg3: Serenity.StringEditor;
        RecptHeadMesg4: Serenity.StringEditor;
        RecptHeadMesg5: Serenity.StringEditor;
        RecptHeadMesg6: Serenity.StringEditor;
        RecptFootMesgFontSize: Serenity.StringEditor;
        RecptFootMesgTextAlign: Serenity.RadioButtonEditor;
        RecptFootMesg1: Serenity.StringEditor;
        RecptFootMesg2: Serenity.StringEditor;
        RecptFootMesg3: Serenity.StringEditor;
        RecptFootMesg4: Serenity.StringEditor;
        RecptFootMesg5: Serenity.StringEditor;
        RecptFootMesg6: Serenity.StringEditor;
        RecptFootMesg7: Serenity.StringEditor;
        RecptFootMesg8: Serenity.StringEditor;
        RecptFootMesg9: Serenity.StringEditor;
        RecptFootMesg10: Serenity.StringEditor;
        RecptNoBarcodeFg: Serenity.EnumEditor;
        PsParaDefault2: Serenity.BooleanEditor;
        SalesVatType: Serenity.RadioButtonEditor;
        SelectSellingPriceFg: Serenity.EnumEditor;
        ReceiptPrinterType: Serenity.EnumEditor;
        EjournalFg: Serenity.EnumEditor;
        RecptSumItemQtyFg: Serenity.EnumEditor;
        NoOfRecptCopy: Serenity.IntegerEditor;
        SalesDocFg: Serenity.EnumEditor;
        PrintOrderFg: Serenity.EnumEditor;
        PrintQueueFg: Serenity.EnumEditor;
        ItemOnRecptMethod: Serenity.EnumEditor;
    }

    export class PsPosStationForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPosStation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosStationForm.init)  {
                PsPosStationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(PsPosStationForm, [
                    'PosId', w0,
                    'PosPermitNo', w0,
                    'ShopId', w1,
                    'WhsId', w1,
                    'LastReceiptRunNo', w2,
                    'LastRefundRunNo', w2,
                    'CashierPosFg', w3,
                    'PromptPayLink', w0,
                    'PosScreenType', w4,
                    'QRCodeAccount', w0,
                    'PosTouchPanelId', w1,
                    'MaxCashInDrawer', w2,
                    'SellingPriceNo', w3,
                    'AutoChargeFg', w3,
                    'AutoChargeRate', w2,
                    'MandatorySalesmanFg', w3,
                    'MandatoryMemberFg', w3,
                    'ConnectPrinterFg', w3,
                    'ConnectDrawerFg', w3,
                    'ConnectVfdFg', w3,
                    'Connect2ndDispFg', w3,
                    'ConnectRfidReaderFg', w3,
                    'ConnectEdcFg', w3,
                    'ConnectEdcPort', w1,
                    'EdcBank', w1,
                    'PsParaDefault1', w5,
                    'ShopLogoOnFrontScreen', w6,
                    'ShopLogoOnReceipt', w6,
                    'RecptHeadMesgFontSize', w0,
                    'RecptHeadMesgTextAlign', w4,
                    'RecptHeadMesg1', w0,
                    'RecptHeadMesg2', w0,
                    'RecptHeadMesg3', w0,
                    'RecptHeadMesg4', w0,
                    'RecptHeadMesg5', w0,
                    'RecptHeadMesg6', w0,
                    'RecptFootMesgFontSize', w0,
                    'RecptFootMesgTextAlign', w4,
                    'RecptFootMesg1', w0,
                    'RecptFootMesg2', w0,
                    'RecptFootMesg3', w0,
                    'RecptFootMesg4', w0,
                    'RecptFootMesg5', w0,
                    'RecptFootMesg6', w0,
                    'RecptFootMesg7', w0,
                    'RecptFootMesg8', w0,
                    'RecptFootMesg9', w0,
                    'RecptFootMesg10', w0,
                    'RecptNoBarcodeFg', w3,
                    'PsParaDefault2', w5,
                    'SalesVatType', w4,
                    'SelectSellingPriceFg', w3,
                    'ReceiptPrinterType', w3,
                    'EjournalFg', w3,
                    'RecptSumItemQtyFg', w3,
                    'NoOfRecptCopy', w7,
                    'SalesDocFg', w3,
                    'PrintOrderFg', w3,
                    'PrintQueueFg', w3,
                    'ItemOnRecptMethod', w3
                ]);
            }
        }
    }
}
